var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-select", {
    attrs: {
      filter: "",
      "autofocus-filter": "",
      chips: _vm.options.length <= 14 ? true : false,
      "display-value":
        _vm.options.length >= 15
          ? _vm.filters.length > 0
            ? _vm.filterCount + " itens selecionados"
            : null
          : null,
      options: _vm.options,
      multiple: "",
      "float-label": _vm.$t(_vm.label),
      clearable: "",
      error: _vm.error ? _vm.error : null,
      disable: _vm.disable
    },
    on: { input: _vm.onInput },
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }